export enum LINK_STATUSES {
  expired,
  used,
  notActual,
  error,
}
